export const BRAND_INDEX = 'brand'
export const FEATURES_INDEX = 'features'
